import { dataTravelEarthPlaneSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTravelEarthPlaneSolid = /*#__PURE__*/createIcon(dataTravelEarthPlaneSolid)
export default IconTravelEarthPlaneSolid
